// src/App.js
import React, {useEffect} from 'react';
import AdminLayout from './shared/AdminLayout';
import {LayoutProvider} from './context/LayoutContext';
import {AuthProvider} from './context/AuthContext';
import './App.css';
import {ToastContainer} from "react-toastify";
import {useAuth} from "./context/AuthContext";
import {setupAxios} from "./shared/AxiosConfig";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import { useGlobalAutofillKill } from "./shared/useGlobalAutofillKill";


const AppInner = () => {

    return (
        <Routes>
            <Route path="/*" element={<AdminLayout/>}/>
        </Routes>
    );
};

function App() {
    useGlobalAutofillKill();

    return (
        <Router>
            <AuthProvider>
                <LayoutProvider>

                    <AppInner/>

                    {/* 🔥 TEK ToastContainer BURADA */}
                    <ToastContainer
                        position="top-right"
                        autoClose={4000}
                        hideProgressBar={false}
                        newestOnTop
                        theme="dark"
                    />


                </LayoutProvider>
            </AuthProvider>
        </Router>
    );
}

export default App;
